import api from '@/utils/api';
import { getBase64 } from '@/utils/helpers';

class UploadAdapter {
    constructor(loader, uploadFile = null) {
        this.loader = loader;
        this.uploadFile = uploadFile;
    }

    async upload() {
        try {
            const file = await this.loader.file;
            const fileBase64 = await getBase64(file);
            const file_name = file.name;
            const fileData = {
                file_name: file_name,
                fileBase64: fileBase64
            };
            if (this.uploadFile) {
                const imageUrl = await this.uploadFile(fileData);
                return { default: imageUrl };
            }

            const res = await api.post('/upload', { files: [fileData] });
            const responseData = res.data;
            const [image] = responseData.data;
            if (responseData.status === "success") {
                return {
                    default: image
                };
            } else {
                throw new Error(responseData.msg || 'Upload failed');
            }
        } catch (error) {
            console.error(error);
            throw new Error('Upload failed');
        }
    }

    abort() {
        // Implement if needed
    }
}

export default UploadAdapter;
